import { render, staticRenderFns } from "./HistorySearch.vue?vue&type=template&id=1dab5ab6"
import script from "./HistorySearch.vue?vue&type=script&lang=js"
export * from "./HistorySearch.vue?vue&type=script&lang=js"
import style0 from "./HistorySearch.vue?vue&type=style&index=0&id=1dab5ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports